import PropTypes from 'prop-types';
import { Navigate, useMatch } from 'react-router-dom';

import { ErrorBoundary } from '@zenbusiness/application-commons-logging';
import PageError from '@zenbusiness/zui/PageError';
import PageLoading from '@zenbusiness/zui/PageLoading';

import { DEFAULT_SEGMENT, NAME } from '#client/build-env';
import { useDashboardPath } from '#client/hooks/useDashboardPath';
import { usePartnerEntity } from '#client/hooks/usePartnerEntity';

function CustomerRouteGuardInner({ children }) {
  const { isPartner, loading } = usePartnerEntity();
  const isAtEntityIndex = useMatch(`${DEFAULT_SEGMENT}/:businessEntityUuid`);
  const dashboardPath = useDashboardPath();

  if (loading) return <PageLoading />;

  if (isPartner && !isAtEntityIndex) {
    return <Navigate to={dashboardPath} replace />;
  }

  return children;
}

CustomerRouteGuardInner.propTypes = {
  children: PropTypes.node.isRequired
};

export default function CustomerRouteGuard({ children }) {
  return (
    <ErrorBoundary fallback={<PageError />} id={`${NAME}/App/CustomerRouteGuard`}>
      <CustomerRouteGuardInner>
        {children}
      </CustomerRouteGuardInner>
    </ErrorBoundary>
  );
}

CustomerRouteGuard.propTypes = {
  children: PropTypes.node.isRequired
};
